import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService, registroConfigService } from '../services/api';
import { formatPersonName } from '../utils/personName';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const isAuthenticated = authService.isAuthenticated();
  const currentUser = authService.getCurrentUser();
  const [registroHabilitado, setRegistroHabilitado] = useState(true);

  useEffect(() => {
    if (isAuthenticated) return;
    registroConfigService.get()
      .then((data) => setRegistroHabilitado(data.registro_habilitado !== false))
      .catch(() => {});
  }, [isAuthenticated]);

  const handleLogout = async () => {
    await authService.logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={`${process.env.PUBLIC_URL || ''}/images/logotecno3f.png`} alt="Campus Tecno3F" className="navbar-logo-img" />
        </Link>
        {isAuthenticated && (
          <Link to="/dashboard" className="navbar-link" style={{ marginLeft: '1rem' }}>
            Ir al Panel Principal
          </Link>
        )}
        <ul className="navbar-menu">
          {isAuthenticated ? (
            <>
              <li className="navbar-item">
                <span className="navbar-user">
                  Bienvenido, {formatPersonName(currentUser?.first_name) || 'Usuario'}
                </span>
              </li>
              <li className="navbar-item">
                <button onClick={handleLogout} className="navbar-button">
                  Cerrar Sesión
                </button>
              </li>
            </>
          ) : (
            <>
              <li className="navbar-item">
                <Link to="/login" className="navbar-link">
                  Iniciar Sesión
                </Link>
              </li>
              {registroHabilitado && (
                <li className="navbar-item">
                  <Link to="/register" className="navbar-link navbar-link-primary">
                    Registrarse
                  </Link>
                </li>
              )}
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;

